let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9eSLL")).then(() => parcelRequire('esyh1'));